import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpBiddingCurveTable
     * @memberof app
     *
     * @restrict E
     * @scope {}
     *
     * @description
     * Displaying the bids of a round in a tabular form.
     *
     * @param {app.AuctionWindowDto[]} rounds
     *
     * @author flzemke.btc
     */
    angular
        .module('app')
        .directive('pkpBiddingCurveTable', pkpBiddingCurveTable);

    function pkpBiddingCurveTable(authService) {
        return {
            restrict: 'E',
            scope: {
                rounds: '='
            },
            template:
                require('app/_directives/pkp-bidding-curve-table.directive.html'),
            controller: controllerFn
        };

        function controllerFn($scope) {
            (function init() {
                authService
                    .getLoggedInUserAsync()
                    .then(function (loggedInUser) {
                        $scope.loggedIn = !!loggedInUser;
                    });
            })();
        }
    }
})();
